<template>
  <v-menu
    v-model="menu_ativo"
    :close-on-content-click="false"
    transition="scale-transition"
    :min-width="400"
  >
    <template v-slot:activator="{}">
      <SysBtn :size="3" class="mr-3 cursor-pointer" @click="ativarMenu">
        <v-icon size="18">mdi-filter-variant</v-icon>
        <span class="ml-1">Qtd. Linhas Por Nível</span>
        <span class="font-12 text-gray-900 ml-2px">({{ formatarValor(LIMITE_LINHAS_POR_NIVEL_STORE) }})</span>
      </SysBtn>
    </template>

    <div class="bg-white">
      <div class="d-flex align-center pa-2">
        <div class="pl-1">
          <p class="ma-0 font-16 font-weight-medium">Quantidade de Linhas Por Nível de Expansão</p>
          <p class="ma-0 font-12 font-weight-regular mt-n1 text-gray-200">Valor Máximo permitido é 1.000</p>
        </div>

        <v-spacer />

        <v-btn icon @click="menu_ativo = false">
          <v-icon :size="22">mdi-close</v-icon>
        </v-btn>
      </div>

      <div class="d-flex align-center px-3 pb-4">
        <TextFieldFormatadorDeValor
          v-model="limite_linhas_por_nivel"
          outlined
          dense
          hide-details
          inteiro
          :error="!limite_linhas_por_nivel || limite_linhas_por_nivel < 1 && limite_linhas_por_nivel > limite_maximo_linhas_por_nivel"
          @focus="ev => ev.target.select()"
          @keydown.enter="aplicarLimiteLinhasPorNivel"
        />

        <v-btn dark class="ml-2" color="#0a3950" @click="aplicarLimiteLinhasPorNivel">
          salvar
        </v-btn>
      </div>
    </div>
  </v-menu>
</template>

<script setup>
import {computed, ref} from "vue";
import store from "@/store";
import TextFieldFormatadorDeValor from "@/components/utils/TextFieldFormatadorDeValor.vue";
import {formatarValor} from "@/helpers/index.js";

const menu_ativo = ref(false);
const limite_linhas_por_nivel = ref(0);

const limite_maximo_linhas_por_nivel = 1000;

const LIMITE_LINHAS_POR_NIVEL_STORE = computed({
  get: () => store.getters["diagnosticoAnaliseQualitativaEstoque/limiteLinhasPorNivel"],
  set: valor => store.dispatch("diagnosticoAnaliseQualitativaEstoque/limiteLinhasPorNivel", valor),
});

function ativarMenu() {
  limite_linhas_por_nivel.value = LIMITE_LINHAS_POR_NIVEL_STORE.value;
  menu_ativo.value = true;
}

function aplicarLimiteLinhasPorNivel() {
  menu_ativo.value = false;
  LIMITE_LINHAS_POR_NIVEL_STORE.value = Math.min((limite_linhas_por_nivel.value || 1), limite_maximo_linhas_por_nivel);
}
</script>
